import { SearchLabel } from '@/search/types'

export const MAX_DISPLAY_PAGE_NUMBER = 10
export const NUMBER_ITEM_PER_PAGE = 40
export const DEFAULT_SORT_ORDER = 'sku_asc'
export const PRINTING_METHOD_ALL = 'all'
export const PRINTING_METHOD_FULL = 'full'
export const PRINTING_METHOD_SINGLE = 'single'
export const FACET_TYPE: { [key: string] : string} = {
  CHECK_BOX: 'checkbox',
  IMAGE: 'image'
}
export const FACET_INDIVIDUAL = 'individual_page'
export const ALL_CATEGORIES = 'すべてのカテゴリー'
export const PRODUCT_CATEGORY = '商品カテゴリー'
export const RAKSUL_TITLE = 'ネット印刷のラクスル'

export const PRINTING_METHOD: SearchLabel[] = [{
    value: 'full',
    label: 'フルカラー印刷'
  },{
    value: 'single',
    label: '単色印刷'
  }
]

export const ORDER_METHOD: SearchLabel[] = [{
  value: 'trial',
  label: 'サンプル印刷'
},{
  value: 'plain',
  label: '無地サンプル'
}
]

export const SORT_ORDER: SearchLabel[] = [{
    value: 'sku_asc',
    label: 'おすすめ / 標準 '
  },{
    value: 'unit_price_asc',
    label: '単価が安い順'
  },{
    value: 'unit_price_desc',
    label: '単価が高い順'
  },{
    value: 'min_quantity_asc',
    label: '最低ロット数順'
  },{
    value: 'delivery_date_asc',
    label: '納期が早い順 '
  }
]
export const PRINT_METHODS = {
  full: 'フルカラー印刷',
  single: '単色印刷'
}
export const ORDER_METHOD_TYPE = {
  ALL: 'all',
  PLAIN: 'plain',
  TRIAL: 'trial'
}

export const FACET_QUERY_PREFIX = 'f_'
